import { clerkInstance, clerkLoadedPromise } from '@/clerk-instance';
import { BeforeRequestHook } from 'ky';

export const withClerkAuthHook: BeforeRequestHook = async (req) => {
  try {
    // Ensure Clerk is loaded by waiting for the shared promise.
    await clerkLoadedPromise;
    const token = await clerkInstance?.session?.getToken();
    if (token) {
      req.headers.set('authorization', `Bearer ${token}`);
    }
  } catch (error) {
    console.error('Error setting Clerk token', error);
  }
};
